const {
  runNumberExtender: baseRunNumberExtender
} = require('vue-js-extender');

exports.runNumberExtender = (Vue) => {
  baseRunNumberExtender(Vue);

  //------------------------- Number Extensions -------------------------
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/number.extender.js